// extracted by mini-css-extract-plugin
export default {"label":"src-modules-form-Label-style__label_Vqlnb"};